import {
  DefaultError,
  InfiniteData,
  QueryClient,
  QueryKey,
  useInfiniteQuery as useInfiniteQueryNative,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
} from '@tanstack/react-query'
import { GetAllData } from 'interfaces/api.interfaces'
import { flatten, last } from 'lodash'

export const useInfiniteQuery = <
  TQueryFnData,
  TError = DefaultError,
  TData extends InfiniteData<TQueryFnData> = InfiniteData<TQueryFnData>,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: Omit<
    UseInfiniteQueryOptions<TQueryFnData, TError, TData, TQueryFnData, TQueryKey, number>,
    'getNextPageParam' | 'initialPageParam'
  >,
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> => {
  const result = useInfiniteQueryNative<TQueryFnData, TError, TData, TQueryKey, number>(
    {
      ...options,
      getNextPageParam: (lastPage) => (lastPage as GetAllData<any>)?.next || undefined,
      initialPageParam: 1,
    },
    queryClient,
  )
  return {
    ...result,
    hasNextPage:
      result.hasNextPage &&
      flatten(result.data?.pages.map((page) => (page as GetAllData<any>).results) || []).length <
        (last(result.data?.pages) as GetAllData<any>).count,
  }
}
